export const hourlyRows = []
